import type { Country } from '@tectonics/prs/country';
import { z, ZodType } from 'zod';

export type FieldSchemaFactoryParams = {
  country: Country;
};

export type FieldSchemaFactory = (params: FieldSchemaFactoryParams) => ZodType;

export const validationRule = z.enum(['phone_number', 'email', 'name']);

export type ValidationRule = z.infer<typeof validationRule>;
